{
  "tooltip": {
    "trigger": "axis"
  },
  "legend": {
    "data": ["Men", "Women", "Total"]
  },
  "xAxis": [
    {
      "type": "category",
      "data": ["Month1", "Month2"],
      "axisPointer": {
        "type": "shadow"
      }
    }
  ],
  "yAxis": {
    "type": "value"
  },
  "series": [
    {
      "name": "Men",
      "type": "bar",
      "data": [
        1, 1
      ],
      "label": {
        "show": false
      },
      "itemStyle": {
        "color": "#ADD8E6"
      },
      "silent": true
    },
    {
      "name": "Women",
      "type": "bar",
      "data": [
        1, 0
      ],
      "label": {
        "show": false
      },
      "itemStyle": {
        "color": "#FFC0CB"
      },
      "silent": true
    },
    {
      "name": "Total",
      "type": "line",
      "data": [2, 1],
      "label": {
        "show": true
      },
      "itemStyle": {
        "color": "#000000"
      },
      "silent": true
    }
  ]
}
